import { useTranslation } from "react-i18next"
import { Button, Form, Row } from 'react-bootstrap'
import { useEffect, useState } from "react"
import Select from "react-select"
import customStyles from "../../../components/design/select"

export default function FormMachinery({submit, isNew, inputChange, state}) {
    const { t } = useTranslation()

    const [typeOptions, setTipes] = useState({})

    const handleSelectTypeChange = (e) => {
        inputChange({target:{name: 'type', value: e.value}})
    }

    useEffect(()=>{
        let TypesToUse = [  
            {value: 'Oruga', label: t('machineries.oruga')},
            {value: "Goma", label: t('machineries.goma')},
            {value: "Camión", label: t('machineries.camion')},
            {value: "Mochila", label: t('machineries.mochila')}
        ]

        let optionSelected = null

        if(state.type !== null && state.type !== undefined){
            optionSelected = TypesToUse.find(type => type.value === state.type)
        }

        if(state.typeEdit !== null && state.typeEdit !== undefined){
            optionSelected = TypesToUse.find(type => type.value === state.typeEdit)
        }

        if(state.type === '' || state.typeEdit === ''){
            optionSelected = null
        }

        setTipes({
            options: TypesToUse, 
            selected: optionSelected})
    }, [state.type, state.typeEdit, t])

    return (
        <>
            <Form onSubmit={submit}>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('machineries.plate')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='plate'
                        value={state.plate || state.plateEdit ||  ''}
                        placeholder={t('machineries.plate')}
                        onChange={inputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('machineries.name')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='name'
                        value={state.name || state.nameEdit ||  ''}
                        placeholder={t('machineries.name')}
                        onChange={inputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('machineries.description')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='description'
                        value={state.description || state.descriptionEdit ||  ''}
                        placeholder={t('machineries.description')}
                        onChange={inputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('machineries.type')}</Form.Label>
                    <Select onChange={handleSelectTypeChange}
                        name="type"
                        placeholder={t('machineries.type')} 
                        options={typeOptions.options}
                        value={typeOptions.selected}
                        styles={customStyles}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('machineries.chassis')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='chassis'
                        value={state.chassis || state.chassisEdit ||  ''}
                        placeholder={t('machineries.chassis')}
                        onChange={inputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('machineries.roma')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='roma'
                        value={state.roma || state.romaEdit ||  ''}
                        placeholder={t('machineries.roma')}
                        onChange={inputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('machineries.year')}</Form.Label>
                    <Form.Control className="form-control"
                        type='number'
                        name='year'
                        value={state.year || state.yearEdit ||  ''}
                        placeholder={t('machineries.year')}
                        onChange={inputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('machineries.check')}</Form.Label>
                    <Form.Control className="form-control"
                        type='date'
                        name='check'
                        value={state.check?.split('T')[0] || state.checkEdit?.split('T')[0] ||  ''}
                        placeholder={t('machineries.check')}
                        onChange={inputChange}
                    />
                </Form.Group>
                <Row className="text-left custom-card-header-list">
                    {
                        isNew === false
                        ?
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('machineries.update')}</Button>
                        :
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('machineries.new')}</Button>
                    }
                </Row>
            </Form>
        </>
    )    
}
